import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class LocalStorageService {
    brokerId: string;

    setBrokerId(brokerId: string) {
        this.brokerId = brokerId;
    }

    list(): (string | null)[] {
        const result: (string | null)[] = [];
        const items = localStorage.getItem(this.brokerId);
        if (items) {
            const obj = JSON.parse(items);
            for (let i = 0; i < obj.length; i++) {
                if (obj.key(i)) {
                    result.push(obj.key(i));
                }
            }
        }

        return result;
    }

    get(key: string): string | null {
        const items = localStorage.getItem(this.brokerId);
        if (items) {
            const itemsObj = JSON.parse(items);
            return itemsObj[key];
        }

        return null;
    }

    set(key: string, value: string): void {
        const items = localStorage.getItem(this.brokerId);
        if (items) {
            let itemsObj = JSON.parse(items);
            itemsObj = {...itemsObj, [key]: value};
            localStorage.setItem(this.brokerId, JSON.stringify(itemsObj));
        } else {
            localStorage.setItem(this.brokerId, JSON.stringify({[key]: value}));
        }
    }

    clear() {
        localStorage.clear();
    }
}
